import { useNavigate } from 'react-router-dom';
import { AddressableViewLayout } from 'framework/ViewTypes';
import { bindCollection } from 'framework/ViewTypes/contentLayout';
import { getTaskConstructorTableConfig } from './taskConstructorTableConfig';
import useTaskConstructorCollection from './useTaskConstructorCollection';
import useTaskConstructorFilterBar from './useTaskConstructorFilterBar';
import { useTaskConstructorUrl } from '../routing';

const TaskConstructorListPage = () => {
  const navigate = useNavigate();
  const { getCreateUrl } = useTaskConstructorUrl();
  const collection = useTaskConstructorCollection();
  const filterProps = useTaskConstructorFilterBar(collection);
  const binding = bindCollection(
    collection,
    getTaskConstructorTableConfig(collection.rows, () => navigate(getCreateUrl())),
    { searchProps: {}, filterProps },
  );

  return <AddressableViewLayout {...binding.pageProps} />;
};

export default TaskConstructorListPage;
